<script setup lang="ts">
const points = [
  {
    icon: 'mdi-lightbulb-on-outline',
    color: 'primary',
    title: 'Rough is fine',
    description:
      "A title, a sketch of the plan, roughly where and roughly when. That's the whole form.",
  },
  {
    icon: 'mdi-hand-back-right-outline',
    color: 'secondary',
    title: 'Interest, not commitment',
    description:
      "Nobody's charged and nobody's committed. It's a show of hands, not a ticket.",
  },
  {
    icon: 'mdi-rocket-launch-outline',
    color: 'tertiary',
    title: "Turn it real when it's worth it",
    description:
      'When the interest is there, promote it into a proper event. Your details carry over, and everyone who raised a hand hears about it.',
  },
];
</script>

<template>
  <section class="ideas-section marketing-section">
    <div class="marketing-section__content">
      <h2 class="text-h4 text-center font-weight-bold mb-4">
        Not ready to plan it? Float the idea.
      </h2>
      <p
        class="text-body-1 text-center text-medium-emphasis mb-10"
        style="max-width: 640px; margin-inline: auto"
      >
        You don't need dates, a venue, or a budget to find out whether anyone's
        interested. Post a rough idea &mdash; roughly where, roughly when
        &mdash; and see who raises a hand.
      </p>

      <v-row class="mb-10">
        <v-col v-for="(point, i) in points" :key="i" cols="12" md="4">
          <div class="text-center">
            <v-avatar :color="point.color" size="64" class="mb-4">
              <v-icon size="32" color="white">{{ point.icon }}</v-icon>
            </v-avatar>
            <h3 class="text-subtitle-1 font-weight-bold mb-2">
              {{ point.title }}
            </h3>
            <p class="text-body-2 text-medium-emphasis mb-0">
              {{ point.description }}
            </p>
          </div>
        </v-col>
      </v-row>

      <div class="text-center">
        <v-btn to="/ideas/create" color="primary" size="large" class="mb-3">
          Float an idea
        </v-btn>
        <p class="text-body-2 text-medium-emphasis mb-0">
          <NuxtLink to="/browse" class="font-weight-bold">
            See what people are floating
          </NuxtLink>
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.ideas-section {
  background: var(--arvee-surface-warm);
}
</style>
